export default function PropacityImages() {
    return (
        <div className='flex flex-col justify-center items-center gap-5 md:gap-9 mt-[48px] md:mt-[98px]'>
            <img src='https://ik.imagekit.io/bpfumapog/propacity1.png?tr=f-auto,q-80' alt='propacity1' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/propacity4.png?tr=f-auto,q-80' alt='propacity4' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/propacity5.png?tr=f-auto,q-80' alt='propacity5' className='max-w-[390px] md:max-w-[996px]'/>
            <div className='flex justify-between items-center gap-4 md:gap-8'>
                <img src='https://ik.imagekit.io/bpfumapog/propacity2-1.png?tr=f-auto,q-80' alt='propacity2_1' className='max-w-[187px] md:max-w-[482px]'/>
                <img src='https://ik.imagekit.io/bpfumapog/propacity2-2.png?tr=f-auto,q-80' alt='propacity2_2' className='max-w-[187px] md:max-w-[482px]'/>
            </div>
            <img src='https://ik.imagekit.io/bpfumapog/propacity3.png?tr=f-auto,q-80' alt='propacity3' className='max-w-[390px] md:max-w-[996px]'/>
        </div>
    )

}
